import { render, staticRenderFns } from "./DsTooltip.vue?vue&type=template&id=95eac328&scoped=true&"
import script from "./DsTooltip.vue?vue&type=script&lang=js&"
export * from "./DsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DsTooltip.vue?vue&type=style&index=0&id=95eac328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eac328",
  null
  
)

export default component.exports